/**
 * A function that does nothing.
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function noop() { }
//# sourceMappingURL=noop.js.map